interface State {
    hasError: boolean
}

export class ErrorBoundary extends React.Component<{}, State> {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {

        const data = {
            error: JSON.stringify(error, Object.getOwnPropertyNames(error), 2),
            info
        }

        console.error("ErrorBoundary", data)

    }

    render() {
        if (this.state.hasError) {
            return <span className="danger">
                <i className="fas fa-exclamation-triangle"></i> {" "}Error
            </span>
        }

        return <>{this.props.children}</>
    }

}
